import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { Tool } from '../utils/tool.utils';

export const setActiveTool = action(
  '[Tool] setActiveTool',
  props<{ tool: Tool | null } & SkipHistory>(),
);
